let currentPage = 1;
let totalPages = null;

export default {
  init() {
    let that = this;
    // counter used for paginating correctly
    window.categoryPageLoaderCounter = 1;
    let defaultTag = $('#filter-tags').find(':selected').val();
    that.getData(1, defaultTag);
    //fill the dates
    // that.loadPostsDates();
    that.initFilters();
    that.loadMoreHandler();
  },

  initFilters() {
    let that = this;

    $('#filter-dates').on('change', function () {
      const val = $(this).val();
      const tags = $('#filter-tags').val();
      that.getData(1, tags, val);
    });

    $('#filter-tags').on('change', function () {
      const val = $(this).val();
      const dates = $('#filter-dates').val();
      that.getData(1, val, dates);
    });
  },

  loadMoreHandler() {
    $('.publications-loadMore button').on('click', (event) => {
      $(event.currentTarget).addClass(
        'hover:bg-mango-tango bg-opacity-50 hover:bg-opacity-50 cursor-not-allowed'
      );
      $('.publications-loadMore button').removeClass('hover:bg-blue-prussian');
      $(event.currentTarget).prop('disabled', true);
      $(event.currentTarget).html(`
        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg> Load More
      `);
      window.isLoadingMorePosts = true;
      this.getData(
        ++window.categoryPageLoaderCounter,
        window.currentCategoryFilter
      );
    });
  },

  getData(page_num, defaultTag, dates) {
    let that = this;

    $.ajax({
      type: 'GET',
      url: document.location.origin + '/wp-json/api/v1/publications_data',
      data: {
        page: page_num,
        tag: defaultTag,
        year: dates || null,
      },
      beforeSend: function () {
        // Only if we're not loading more posts we will clear the article's list container.
        if (!window.isLoadingMorePosts) {
          $('#publications-list').html('');
          $('#publications-loader').addClass('flex');
          $('#publications-loader').removeClass('hidden');
          $('#publications-empty').addClass('hidden');
          $('#publications-empty').removeClass('flex');
          $('.publications-loadMore').addClass('hidden');
        }
      },
      success: function (data) {
        currentPage = parseInt(data.current_page);
        totalPages = parseInt(data.total_pages);

        // handle when to show the loadmore button.
        if (totalPages > 1 && totalPages > currentPage) {
          $('.publications-loadMore').removeClass('hidden');
        }

        // Handles when to show the empty message when querying.
        if (data.length === 0) {
          $('#publications-empty').removeClass('hidden');
          $('#publications-empty').addClass('flex');
        } else {
          $('#publications-empty').addClass('hidden');
          $('#publications-empty').removeClass('flex');
          that.drawHtml(data);
          window.initLazyLoad.update();
        }

        // Hide the load more button if the results only contain one page.
        if (currentPage === totalPages) {
          $('.publications-loadMore').addClass('hidden');
        }
      },

      complete: function () {
        $('.publications-loadMore button').html('Load More');
        $('.publications-loadMore button').addClass('hover:bg-blue-prussian');
        $('.publications-loadMore button').removeClass(
          'hover:bg-mango-tango bg-opacity-50 hover:bg-opacity-50 cursor-not-allowed'
        );
        $('.publications-loadMore button').prop('disabled', false);

        if (!window.isLoadingMorePosts) {
          $('#publications-loader').addClass('hidden');
          $('#publications-loader').removeClass('flex');
        }
      },
    });
  },

  drawHtml(data) {
    const scrollTop = $(window).scrollTop();

    $.each(data, function (idx, item) {
      $('#publications-list').append(`
        <div id="publication-${item.id}" class="publication-item flex flex-col md:flex-row shadow-md bg-white">
          <div class="flex flex-col justify-between flex-shrink custom-full-width">
            <div class="
              content-wrapper
              flex flex-col
              px-5 xl:px-8 2xl:px-9
              py-8 lg:py-10
            ">
              <div class="heading-area mb-5 flex flex-wrap xl:flex-nowrap gap-5 xl:gap-10 custom-flex">

                <div>
                <div class="heading-area mb-5">
                 <span class='text-xs text-mango-tango tracking-widest font-bold uppercase'>${item.tags}</span>
                </div>
                  <h2 class="title text-4xl text-blue-prussian font-light tracking-tight mb-3" title="${item.title}">
                    ${item.title}
                  </h2>
                </div>
                <div class="heading-area mb-5">
                  <span class="text-xs text-gray-shuttle tracking-widest font-bold uppercase whitespace-nowrap">${item.date}</span>
                </div>

              </div>


              <div>
                <a class="text-base uppercase text-blue-prussian tracking-wider font-medium mt-auto link-underlined-hover" href="${item.permalink}">Read More</a>
              </div>
            </div>
          </div>
        </div>
      `);

      $(window).scrollTop(scrollTop);
    });
  },

  loadPostsDates() {
    $.ajax({
      type: 'GET',
      url: document.location.origin + '/wp-json/api/v1/publication_years',
      data: {
        //pass args to the endpoint if needed
      },
      beforeSend: function () {
        //do something before the ajax sends
      },
      success: function (data) {
        //we get the years of the posts on the site
        data.forEach((element) => {
          $('#filter-dates').append(`
            <option value="${element}">${element}</option>
          `);
        });
      },

      complete: function () {
        //do something on request completed
      },
    });
  },
};
